import { DebouncedSave } from 'articleEditor/contexts/savingContext';
import { createMyPluginFactory } from 'lib-knowledge-document-structure/plateFunctions';

export interface HeadingsPlugin {
  debouncedSave: DebouncedSave;
}

export const createSaveArticlePlugin = createMyPluginFactory({
  key: 'save-article',
  then: (editor, { options: { debouncedSave } = {} }) => {
    return {
      handlers: {
        onBlur: () => () => {
          debouncedSave.flush();
        },
        onChange: () => () => {
          debouncedSave();
        },
      },
    };
  },
});
